import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Drilldown from 'highcharts/modules/drilldown';
import redirectURL from "../redirectURL";
import 'react-datetime/css/react-datetime.css';
import Datetime from 'react-datetime';
import moment from "moment";

Drilldown(Highcharts);  // Enable drill-down functionality

const DeliveryPerfDashboard2 = () => {
    var [overly, setoverly] = useState('show-n');
    var [loadshow, setloadshow] = useState('show-n');
    var [ftlDamage, setFtlDamage] = useState(0);
    var [ftlExcess, setFtlExcess] = useState(0);
    var [ftlShort, setFtlShort] = useState(0);
    var [ftlPilferage, setFtlPilferage] = useState(0);
    var [ptlDamage, setptlDamage] = useState(0);
    var [ptlExcess, setptlExcess] = useState(0);
    var [ptlShort, setptlShort] = useState(0);
    var [ptlPilferage, setptlPilferage] = useState(0);
    const [chartOptions, setChartOptions] = useState({});  // State to store chart options
    var [from_date, setfrom_date] = useState(moment().format('DD-MM-YYYY'));
    var [end_date, setend_date] = useState(moment().add(2, 'days').format('DD-MM-YYYY'));
    var [ftlDeliveredCount, setFtlDeliveredCount ] = useState(0);
    var [ptlDeliveredCount, setPtlDeliveredCount ] = useState(0);
    var [ftlIntransitCount, setFtlIntransitCount ] = useState(0);
    var [ptlIntransitCount, setPtlIntransitCount ] = useState(0);
    var [ontimeFtlDeliveredCount, setOntimeFtlDelivered ] = useState(0);
    var [delayFtlDeliveredCount, setDelayFtlDelivered ] = useState(0);
    var [delayFtlIntransitCount, setDelayFtlIntransit ] = useState(0);
    var [ontimeFtlIntransitCount, setOntimeFtlIntransit ] = useState(0);
    var [ontimePtlDeliveredCount, setOntimePtlDelivered ] = useState(0);
    var [delayPtlDeliveredCount, setDelayPtlDelivered ] = useState(0);
    var [ontimePtlIntransitCount, setOntimePtlIntransit ] = useState(0);
    var [delayPtlIntransitCount, setDelayPtlIntransit ] = useState(0);

    useEffect(() => {
        getData();
        if (ftlDeliveredCount !=0 || ptlDeliveredCount !=0){
            resetDrilldownState()
        }
    }, [ftlDeliveredCount, ptlDeliveredCount]);

    const getData = (from_date, to_date) => {
        setloadshow('show-m'); 
        var params = {
            from_date: formatDate(from_date),
            to_date: formatDate(to_date),
        };
        const calculateDeliveryStatus = (data, statusField, countField) => {
            let onTime = 0;
            let delayed = 0;
            
            data.forEach(item => {
                if (item[statusField] == 1) {
                    onTime += item[countField];
                } else {
                    delayed += item[countField];
                }
            });
        
            return { onTime, delayed };
        };
        
        const calculateTotal = (data, countField) => {
            return data.reduce((acc, curr) => acc + curr[countField], 0);
        };
        
        redirectURL.post('/consignments/getdeliveryperformance', params).then((resp) => {
            try {
                const data = resp.data;
        
                const ftlData = data.ftl_consignments;
                const ptlData = data.ptl_consignments;
                const ftlDelivered = JSON.parse(ftlData.overall_delivered);
                const ptlDelivered = JSON.parse(ptlData.overall_delivered);
                const ftlIntransit = JSON.parse(ftlData.overall_intransit);
                const ptlIntransit = JSON.parse(ptlData.overall_intransit);
        
                // Calculate FTL on-time and delayed deliveries
                const { onTime: onTimeFtlDelivered, delayed: delayFtlDelivered } = calculateDeliveryStatus(ftlDelivered, 'ontime_status', 'type_count');
                setOntimeFtlDelivered(onTimeFtlDelivered);
                setDelayFtlDelivered(delayFtlDelivered);
        
                // Calculate FTL on-time and delayed in transit
                const { onTime: onTimeFtlIntransit, delayed: delayFtlIntransit } = calculateDeliveryStatus(ftlIntransit, 'ontime_status', 'type_count');
                setOntimeFtlIntransit(onTimeFtlIntransit);
                setDelayFtlIntransit(delayFtlIntransit);
        
                // Calculate PTL on-time and delayed deliveries
                const { onTime: onTimePtlDelivered, delayed: delayPtlDelivered } = calculateDeliveryStatus(ptlDelivered, 'ontime_status', 'type_count');
                setOntimePtlDelivered(onTimePtlDelivered);
                setDelayPtlDelivered(delayPtlDelivered);
        
                // Calculate PTL on-time and delayed in transit
                const { onTime: onTimePtlIntransit, delayed: delayPtlIntransit } = calculateDeliveryStatus(ptlIntransit, 'ontime_status', 'type_count');
                setOntimePtlIntransit(onTimePtlIntransit);
                setDelayPtlIntransit(delayPtlIntransit);
        
                // Calculate totals for FTL and PTL deliveries and in-transit
                const sumOfDeliveredFTL = calculateTotal(ftlDelivered, 'type_count');
                const sumOfDeliveredPTL = calculateTotal(ptlDelivered, 'type_count');
                const sumOfIntransitFTL = calculateTotal(ftlIntransit, 'type_count');
                const sumOfIntransitPTL = calculateTotal(ptlIntransit, 'type_count');
        
                setFtlDeliveredCount(sumOfDeliveredFTL);
                setPtlDeliveredCount(sumOfDeliveredPTL);
                setFtlIntransitCount(sumOfIntransitFTL);
                setPtlIntransitCount(sumOfIntransitPTL);
        
            } catch (e) {
                console.error('Error:', e);
            } finally {
                setTimeout(() => {
                    setloadshow('show-n');
                }, 3000);
            }
        }).catch(error => {
            console.error('Fetch error:', error);
            setTimeout(() => {
                setloadshow('show-n');
            }, 3000);
        });
        
        
    };
    
    const resetDrilldownState = () => {        
        setChartOptions({
            chart: {
                type: 'column',
                height: 250,
                events: {
                    // Handle drilldown event
                    drilldown: function (e) {
                        console.log('Drilldown event:', e.point.name);
                        this.redraw(); // Force chart redraw after drilldown
                    },
                    // Handle drillup event to reset state
                    drillup: function () {
                        console.log('Drillup event: returning to higher level');
                        this.redraw(); // Force chart redraw after drillup
                    }
                }
            },
            title: {
                text: ''
            },
            xAxis: {
                type: 'category',
            },
            yAxis: {
                title: {
                    text: 'No. of Shipments'
                }
            },
            plotOptions: {
                series: {
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}'
                    }
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
            },
            series: [
                {
                    name: "Delivered",
                    colorByPoint: true,
                    data: [
                        {
                            name: "FTL Delivered",
                            y: ftlDeliveredCount,  // Use state variables
                            drilldown: "deliveredFTL",
                            color: '#1cc88a'  // Blue color for FTL delivered
                        },
                        {
                            name: "PTL Delivered",
                            y: ptlDeliveredCount,
                            drilldown: "deliveredPTL",
                            color: '#1cc88a'  // Orange color for FTL in transit
                        }
                    ]
                },
                {
                    name: "In Transit",
                    colorByPoint: true,
                    data: [
                        {
                            name: "FTL In Transit",
                            y:ftlIntransitCount,
                            drilldown: "intransitFTL",
                            color: '#28bad4'  // Green color for PTL delivered
                        },
                        {
                            name: "PTL In Transit",
                            y: ptlIntransitCount,
                            drilldown: "intransitPTL",
                            color: '#28bad4'  // Red color for PTL in transit
                        }
                    ]
                }
            ],
            drilldown: {
                drillUpButton: {
                    position: {
                        align: 'right',
                        x: -30,
                        y: 10
                    },
                    theme: {
                        fill: 'white',
                        'stroke-width': 1,
                        stroke: 'silver',
                        r: 0,
                        states: {
                            hover: {
                                fill: '#f0f0f0'
                            },
                            select: {
                                stroke: '#039',
                                fill: '#bada55'
                            }
                        }
                    },
                    text: '< Back'  // Updated back button text
                },
                series: [
                    {
                        id: 'deliveredFTL',
                        name: 'FTL Delivered Details',
                        data: [
                            ['On Time', ontimeFtlDeliveredCount],
                            ['Delay', delayFtlDeliveredCount],
                        ]
                    },
                    {
                        id: 'intransitFTL',
                        name: 'FTL In Transit Details',
                        data: [
                            ['On Time', ontimeFtlIntransitCount],
                            ['Delay', delayFtlIntransitCount],
                        ]
                    },
                    {
                        id: 'deliveredPTL',
                        name: 'PTL Delivered Details',
                        data: [
                            ['On Time', ontimePtlDeliveredCount],
                            ['Delay', delayPtlDeliveredCount],
                        ]
                    },
                    {
                        id: 'intransitPTL',
                        name: 'PTL In Transit Details',
                        data: [
                            ['On Time', ontimePtlIntransitCount],
                            ['Delay', delayPtlIntransitCount],
                        ]
                    }
                ]
            },
            credits:false,
            exporting: {
                enabled: false // This disables the context menu (exporting options)
              }
        });
    };

    useEffect(() => {
        resetDrilldownState();
    }, [ftlDamage, ftlExcess, ptlDamage, ptlExcess]);

    const handleDatesSelected = (e) => {
        const date = moment(e).format('DD-MM-YYYY');
        setfrom_date(date);
    };

    const handleDatesSelected1 = (e) => {
        const date = moment(e).format('DD-MM-YYYY');
        setend_date(date);
    };

    const filterDatafordates = () => {
        var from_date1 = from_date;
        var to_date1 = end_date;
        if (from_date1 && to_date1 && from_date1 <= to_date1) {
            getData(from_date1, to_date1);
        } else {
            // setbasicType('From Date should be less than To Date');
            // setbasicType('danger');
            // setshow(true);
        }
    };

    return (
        <>
            <div className='card-header2'>
                <div className='d-flex justify-content-between'>
                    <h1 className='heading3 mt-20p ml-5p' style={{ width: "240px" }}>Delivery Performance</h1>
                    <div className='d-flex'>
                        <div className="row">
                            <div className="form-group col-xl-4 col-lg-4">
                                <div>
                                    <label className='dateStyling'> From Date </label>
                                    <Datetime
                                        className='smaller-datetime'
                                        key={from_date}
                                        placeholder="Date"
                                        disableCloseOnClickOutside={false}
                                        closeOnSelect={true}
                                        value={from_date}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat={false}
                                        onChange={handleDatesSelected}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="form-group col-xl-4 col-lg-4">
                                <div>
                                    <label className='dateStyling'> To Date </label>
                                    <Datetime
                                        className='smaller-datetime'
                                        key={end_date}
                                        placeholder="Date"
                                        disableCloseOnClickOutside={false}
                                        closeOnSelect={true}
                                        value={end_date}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat={false}
                                        onChange={handleDatesSelected1}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="form-group col-xl-4 col-lg-4">
                                <button className="custom-btn1 f10 label label-success mt-30p" onClick={filterDatafordates}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
{                console.log(Highcharts,"Delivery Performance")
}                
                <HighchartsReact highcharts={Highcharts} options={chartOptions} />
            </div>
            <div className={"dataLoadpage1 " + (loadshow)}></div>
            <div className={"dataLoadpageimg " + (loadshow)}>
                <div className="loader-box"><div className="loader"></div></div>
            </div>
            <div className={"overlay-part " + (overly)}></div>
        </>
    );
}

function formatDate(dateString) {
    if (!dateString) {
        console.error('Invalid date string:', dateString);
        return '';
    }
    const parts = dateString.split('-');
    if (parts.length !== 3) {
        console.error('Date string format is incorrect:', dateString);
        return '';
    }
    const [day, month, year] = parts;
    return `${year}-${month}-${day}`;
}

export default DeliveryPerfDashboard2;
